'use client';
import { FC, useState } from 'react';
import {
  Button,
  Flex,
  Spinner,
  Text,
  Textarea,
} from '@eqi-investimentos/react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { useSendSuggestionEvent } from '../../http/client/mutations/useSendSuggestionEvent';

export const ModalSendSuggestion: FC<ModalSendSuggestionProps> = ({
  t,
  isOpen,
  onClose,
}) => {
  const [suggestion, setSuggestion] = useState('');
  const { mutate: sendSuggestion, isPending } = useSendSuggestionEvent();

  if (!isOpen) return <></>;

  const onSubmit = async () => {
    sendSuggestion(
      { suggestion: 'Evento: ' + suggestion },
      { onSuccess: () => setTimeout(() => onClose(), 1000) }
    );
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent w="23.4375rem" minH="23.25rem">
        <ModalCloseButton top="2rem" right="2rem" />
        <ModalBody w="full" transition="all 0.5s ease">
          <Flex
            w="full"
            minH="23rem"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            gap="2xl"
            p="l"
            pt="5xl"
          >
            <Text
              textAlign="start"
              size="xl"
              fontWeight="normal"
              color="content.secondary"
            >
              {t('screens.events.suggestion.title')}
            </Text>

            <Textarea
              aria-label="textarea-modal-send-suggestion"
              placeholder="Escreva aqui..."
              noOfLines={6}
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
                setSuggestion(event?.target?.value)
              }
            />

            <Button
              aria-label="button-modal-send-suggestion"
              variant="solid"
              w="full"
              h="3rem"
              borderRadius="2xs"
              onClick={onSubmit}
              disabled={suggestion?.length < 10}
            >
              {!isPending && t('screens.events.suggestion.button')}
              {isPending && (
                <Spinner size="md" emptyColor="content.alwaysLight" />
              )}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

type ModalSendSuggestionProps = {
  isOpen: boolean;
  onClose: () => void;
  t: (key: string) => string;
};
